module.exports = __webpack_public_path__ + "static/media/Imagen_1.81014c0d.jpg";